import { refLoad } from '../simple/simple.store';
import { checkStoreStatus } from '@/util/util';
import { REF_NAME, REF_PATH } from './Const';

export function getCurrencyListWrapper(state) {
  if (!checkStoreStatus(REF_NAME, REF_PATH, refLoad)) {
    return undefined;
  }
  return state.getIn(['references', 'currency']);
}
